import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from 'app/shared/service/api-service/api-service';
import { Observable } from "rxjs";
import { GoogleMapsLoaderService } from './shared/service/google-service/google-maps-loader.service';

@Injectable()
export class TrovaAtmService {

  /**
   * Stores the base url for service calls
   */
  trovaAtmServiceUrl: string;
  tempGetRegionUrl: string;
  pathEnv:string;

  /**
   * Stores the google API Key
   */
  googleApiKey: string;

  constructor(
    private api: ApiService,
    private http: HttpClient,
    private googleService: GoogleMapsLoaderService

  ) {
    this.trovaAtmServiceUrl = "trovaAtm";
    this.tempGetRegionUrl = "https://atm.staging.findomestic.it/./../assets/rest/v1/trovaAtm/regions.json"
    this.googleApiKey = this.googleService.googleApiKey;
  }

  /**
   * Fetch region list
   */
  // public fillRegionList(): Observable<any> {
  //   return this.api.get(this.trovaAtmServiceUrl + "/getRegionList");
  // }

/* CHIAMATA TEMPORANEA PER TEST*/
  public fillRegionList(): Observable<any> {
    return this.http.get(this.tempGetRegionUrl);
  }
  /**
   * Fetch province list based on region code
   * @param ndg - region code
   */
  public fillProvinceList(ndg: any): Observable<any> {
    let params = {
      'ndg': ndg
    };
    return this.api.get(this.trovaAtmServiceUrl + "/getProvinceList", params);
  }

  /**
   * Fetch the list of Agencies around the selected region
   * @param param - region selected
   */
  public searchAgency(params: any): Observable<any> {
    return this.api.get(this.trovaAtmServiceUrl + "/searchAgency", params);
  }

  /**
   * Fetch the list of ATMs around the selected region-province
   * @param param - lat, long and province acronym selected
   */
  public searchAtm(params: any): Observable<any> {
    return this.api.get(this.trovaAtmServiceUrl + "/searchAtmByProvince", params);
  }

  public searchAtmByRegion(params: any): Observable<any> {
    return this.api.get(this.trovaAtmServiceUrl + "/searchAtmByRegion", params);
  }

  /**
   * Fetch the list of Agencies around the current location (based on latitude and longitude)
   * @param param - latitude and longitude
   */
  public searchAgencyWithCurrentPosition(params: any): Observable<any> {
    return this.api.get(this.trovaAtmServiceUrl + "/searchAgencyWithCurrentPosition", params);
  }

  /**
   * Fetch the list of ATMs around the current location (based on latitude and longitude)
   * @param param - latitude and longitude
   */
  public searchAtmWithCurrentPosition(params: any): Observable<any> {
    return this.api.get(this.trovaAtmServiceUrl + "/searchAtmByCoords", params);
  }

  /**
 * Get reverse geolocalization info (based on latitude and longitude)
 * Response info: https://developers.google.com/maps/documentation/geocoding/start?csw=1#ReverseGeocoding
 * @param param - latitude and longitude
 */
  public reverseGeocodingFromPosition(params: any): Observable<any> {
    const headerDict = {
      'Access-Control-Allow-Headers': '*',
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.api.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + params.latitude + ',' + params.longitude + '&key=' + this.googleApiKey, requestOptions);
  }
  
}